import * as React from "react";
import { cn } from "@/lib/utils";

export interface InputProps
	extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
	({ className, type, onClick, ...props }, ref) => {
		const handleClick = (event: React.MouseEvent<HTMLInputElement>) => {
			(event.currentTarget as HTMLInputElement).select();
			if (onClick) {
				onClick(event);
			}
		};

		return (
			<input
				type={type}
				className={cn(
					`bg-transparent w-full max-h-[18px] min-h-[18px] h-full px-2 text-xs
					text-accent-foreground placeholder:text-accent-foreground/60 
					border border-gray hover:border-light-gray/50 focus:border-light-gray/70 
					outline-hidden rounded-md transition-all cursor-pointer  
					disabled:cursor-not-allowed disabled:opacity-50`,
					className,
				)}
				ref={ref}
				onClick={handleClick}
				{...props}
			/>
		);
	},
);
Input.displayName = "Input";

export { Input };
